import React from 'react';
import sobreNosotrosImg from '../assets/rym.webp';
import { SEO } from '../components/shared/SEO';

export const NosotrosScreen = () => {
  return (
    <div className="section-padding container">
      <SEO
        title="Equipo de Contadoras Públicas en Corrientes"
        description="Conozca a las profesionales matriculadas de R&M Estudio Contable. Asesoramiento estratégico, cercano e integral para empresas y emprendedores en Corrientes Capital."
        keywords="contadoras en corrientes, contadores publicos corrientes capital, equipo contable corrientes, estudio contable rym"
        url="https://rymcontable.com.ar/nosotros"
      />
      <h2 className="text-center">Tu Respaldo Profesional</h2>

      <div className="about-content">
        <div className="about-text" style={{ flex: 1 }}>
          <h3 style={{ fontSize: '1.8rem', marginBottom: '1.5rem' }}>Más que contadoras, socias estratégicas.</h3>
          <p>
            En R&M Estudio Contable, cambiamos el paradigma tradicional. No nos limitamos a procesar datos; nos involucramos en la realidad de su negocio para ofrecer soluciones que generen valor.
          </p>
          <p>
            Creemos en una relación de partnership, donde su crecimiento es nuestro principal indicador de éxito. Transformamos la complejidad de las normativas argentinas en herramientas claras para su toma de decisiones.
          </p>
        </div>
        <div className="about-image" style={{ flex: 1 }}>
          <img
            src={sobreNosotrosImg}
            alt="Equipo Profesional de Contadoras en Corrientes R&M"
            style={{ width: '100%', borderRadius: '8px', boxShadow: 'var(--shadow-soft)' }}
          />
        </div>
      </div>

      <div className="why-us-card" style={{ marginTop: '4rem' }}>
        <h3 className="text-center">Por qué elegirnos</h3>
        <div style={{ display: 'flex', gap: '2rem', marginTop: '2rem', flexWrap: 'wrap' }}>
          <div style={{ flex: 1 }}>
            <h4>Actualización Constante</h4>
            <p>En un país con leyes cambiantes, la actualización no es una opción, es una obligación. Nos capacitamos permanentemente para anticiparnos a los cambios.</p>
          </div>
          <div style={{ flex: 1 }}>
            <h4>Tecnología Aplicada</h4>
            <p>Utilizamos herramientas digitales modernas para agilizar gestiones, eliminando la burocracia innecesaria y brindándole información en tiempo real.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
